module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_play.af4b7.png";